<template>
    <div class="list-container">
        <h2>Medication Summary</h2>
        <button class="btn btn-sm add-btn" @click="$router.push('/dashboard/medications/add')">➕ Add Medication</button>

        <table class="responsive-table mt-3 full-width-table">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Medication</th>
                    <th>Symptom Treated</th>
                    <th>Frequency & Dosage</th>
                    <th style="width: 180px;">Actions</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(med, index) in medications" :key="med.id">
                    <td>{{ index + 1 }}</td>
                    <td>{{ med.name }}</td>
                    <td>{{ med.symptom_treated }}</td>
                    <td>{{ med.frequency_dosage }}</td>
                    <td>
                        <button class="btn btn-sm edit-btn mb-1"
                            @click="$router.push(`/dashboard/medications/edit/${med.id}`)">
                            ✏️ Edit
                        </button>
                        <button class="btn btn-sm delete-btn" @click="deleteMedication(med.id)">
                            🗑️ Delete
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    data() {
        return {
            medications: []
        };
    },
    methods: {
        async fetch() {
            const res = await this.$api.get("/medications");
            this.medications = res.data;
        },
        async deleteMedication(id) {
            if (!confirm("Delete this medication?")) return;
            await this.$api.delete(`/medications/${id}`);
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    }
};
</script>

<style scoped>
.list-container {
    padding: 20px;
    background: white;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.responsive-table tbody td {
    text-align: left;
}


.full-width-table {
    width: 100%;
    border-collapse: collapse;
}

.full-width-table th,
.full-width-table td {
    border: 1px solid #ddd;
    padding: 10px;
    vertical-align: top;
}

.full-width-table th {
    background-color: #f4f4f4;
    text-align: left;
}

.edit-btn {
    background-color: #ffc107;
    border: none;
    color: black;
}

.delete-btn {
    background-color: #dc3545;
    border: none;
    color: white;
}
</style>